import { render, staticRenderFns } from "./CriticalErrorPage.vue?vue&type=template&id=2449bba6&scoped=true"
import script from "./CriticalErrorPage.vue?vue&type=script&lang=js"
export * from "./CriticalErrorPage.vue?vue&type=script&lang=js"
import style0 from "./CriticalErrorPage.vue?vue&type=style&index=0&id=2449bba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449bba6",
  null
  
)

export default component.exports